module.exports = __webpack_public_path__ + "img/list_icon_fk.a97627af.png";